import { useQueryClient } from "@tanstack/react-query";

import { useCurrentCompanyId } from "@/hooks/useCurrentCompanyId";
import { useCurrentJobId } from "@/hooks/useCurrentJobId";
import { CandidacyPlacement, PlacementQueryParams } from "@/types";

export const useAddPlacement = () => {
  const currentCompanyId = useCurrentCompanyId();
  const currentJobId = useCurrentJobId();
  const queryClient = useQueryClient();

  return ({
    newPlacement,
    placementQueryParams,
  }: {
    newPlacement: CandidacyPlacement;
    placementQueryParams: PlacementQueryParams;
  }) => {
    queryClient.setQueryData(
      ["placements", currentCompanyId, currentJobId, placementQueryParams],
      (cachedPlacements: CandidacyPlacement[]) => {
        return [newPlacement, ...cachedPlacements];
      },
    );
  };
};
